import { useState, useEffect } from 'react'

function useLocation() {

    const [locationData, setLocationData] = useState(null);

    const getLocation = async () => {
        try {
            const res = await fetch('https://ipapi.co/json/');
            const data = await res.json();
            setLocationData(data);
        } catch (error) {
            console.error("Could not fetch location data:", error.message);
        }
    }

    useEffect(() => {
        getLocation();
    }, []);

    return {
        city: locationData?.city,
        country: locationData?.country_name,
        countryCode: locationData?.country_code,
        lat: locationData?.latitude,
        lon: locationData?.longitude,
        region: locationData?.region,
        regionCode: locationData?.region_code,
        timezone: locationData?.timezone,
        zip: locationData?.country_calling_code
    }
}

export default useLocation